export const ACTION_URL = "/users/pending-action";

export const actionEndpoints = (builder) => ({
    updateAction: builder.mutation({
        query: ({id, status, comment}) => ({url: `${ACTION_URL}/${id}`, method: 'put', body: {status, comment}}),
        invalidatesTags: ['Themes'],
    }),
    deleteAction: builder.mutation({
        query: ({id}) => ({url: `${ACTION_URL}/${id}`, method: 'delete'}),
        // invalidatesTags: [''],
    }),
})